import LayoutPage from "../../Components/LayoutPage"
import LogsList from "./Components/LogsList"

export default function Logs() {
  return (
    <LayoutPage activeIndex={16} navItems={["لاگ سامانه"]} childrenClassName="flex-1 min-h-0 flex flex-col gap-5 overflow-auto">
      <LogsList/>
    </LayoutPage>
  )
}